import { type LoginInfo } from '~/types';

export default function useProfileLogin (userLoginPayload: LoginInfo | {}) {
  const loggedInUserFirstNameFirstChar = computed(() => {
    const fName = userLoginPayload.firstName || '';
    return fName.length > 0 ? fName[0] : '';
  });

  const loggedInUserLastNameFirstChar = computed(() => {
    const lName = userLoginPayload.lastName || '';
    return lName.length > 0 ? lName[0] : '';
  });

  const showDefaultUserAvatar = computed(() => {
    return loggedInUserFirstNameFirstChar.value.trim().length === 0 && loggedInUserLastNameFirstChar.value.trim().length === 0;
  });

  const loggedInUserUserAvatarName = computed(() => {
    return showDefaultUserAvatar.value ? '' : `${loggedInUserFirstNameFirstChar.value}${loggedInUserLastNameFirstChar.value}`;
  });

  const shouldShowAbonnerButton = computed(() => {
    return userLoginPayload.isLoggedIn ? !userLoginPayload.isSubscriber : true;
  });

  const shouldShowHeaderCTA = computed(() => {
    return userLoginPayload.isLoggedIn && userLoginPayload.isSubscriber;
  });

  const subscriptionType = computed(() => {
    if (userLoginPayload.isTotalSubscriber) {
      return 'Total user';
    }
    return userLoginPayload.isSubscriber ? 'Basic subscriber' : 'Non subscriber';
  });

  return {
    subscriptionType,
    shouldShowAbonnerButton,
    shouldShowHeaderCTA,
    loggedInUserFirstNameFirstChar,
    loggedInUserLastNameFirstChar,
    showDefaultUserAvatar,
    loggedInUserUserAvatarName
  };
}

export const b64DecodeUnicode = (encodedString: string) => new TextDecoder().decode(Uint8Array.from(window.atob(encodedString), m => m.codePointAt(0) as number));

export const getNcpIdHash = (): string => {
  try {
    const runtimeConfig = useRuntimeConfig().public;
    const cookieName = runtimeConfig.subscribedProductCookie || '';
    if (cookieName !== 'DN_Investor') { return ''; }
    const investorCookie = useCookie(cookieName);
    if (!investorCookie.value) { return ''; }
    const decodedInvestorCookie = b64DecodeUnicode(investorCookie.value);
    const investorInfo = decodedInvestorCookie.split('|');
    return investorInfo != null && investorInfo.length >= 1
      ? JSON.parse(investorInfo[0]).ncpid
      : '';
  } catch (e) {
    return '';
  }
};

export const extractLoginInfoFromLocalStorage = (key: string): LoginInfo | {} => {
  const storedValue = window.localStorage.getItem(key);
  if (storedValue) {
    try {
      const parsed = JSON.parse(storedValue);
      const v = parsed.value || {};
      return {
        username: v.username,
        firstName: v.first_name,
        lastName: v.last_name,
        ncpIdHash: getNcpIdHash(),
        hasTotal: v.has_total,
        brazeId: v.braze_id,
        oneId: v.one_id || ''
      };
    } catch {
      console.error('Error parsing stored value for login Info');
      return {};
    }
  }
  return {};
};
